import {
  Box,
  Image,
  Stack,
  Text,
  rem,
  Flex,
  Title,
  em,
  Group,
  Divider,
  Container,
  Button,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import Navigation from "../Navigation";
import React from "react";

export default function CareersPage() {
  const isMobile = useMediaQuery(`(max-width: ${em(750)})`);

  const JoinUsTitle = () => (
    <Stack justify="center" align="center" h={"100%"} gap={0} w={"100%"} px={"xl"}>
      <Text
        fw={600}
        lh={1.2}
        fz={rem(isMobile ? 25 : 85)}
        variant="gradient"
        gradient={{ from: "red", to: "orange", deg: 90 }}
      >
        Join Our
      </Text>
      <Text
        lh={1.2}
        fw={600}
        fz={rem(isMobile ? 25 : 85)}
        variant="gradient"
        gradient={{ from: "red", to: "orange", deg: 90 }}
      >
        Team
      </Text>
    </Stack>
  );

  const jobs = [
    {
      title: "Senior Game Developer",
      description: "Hybrid/Remote - Full-Time - Ankara/Turkey",
      id: "senior-game-developer",
    },
    {
      title: "Technical Game Artist",
      description: "Hybrid/Remote - Full-Time - Ankara/Turkey",
      id: "technical-game-artist",
    },
    {
      title: " Senior Project Manager, Game Development",
      description: "Hybrid/Remote - Full-Time - Ankara/Turkey",
      id: "senior-project-manager-game-development",
    },
    {
      title: "Senior Game Designer",
      description: "Hybrid/Remote - Full-Time - Ankara/Turkey",
      id: "senior-game-designer",
    },
    {
      title: "Senior Full-Stack Web Developer",
      description: "Hybrid - Full-Time - Ankara/Turkey",
      id: "senior-fullstack-web-developer",
    },
    {
      title: "Marketing & Content Specialist",
      description: "Remote - Full-Time - Global Marketing",
      id: "marketing-content-specialist",
    },
  ];

  const JobLine = ({ title, description, id }) => (
    <Group justify={"space-between"} align={"center"} p={"md"} wrap="nowrap" gap={"xs"}>
      <Box>
        <Title
          c={"dark.3"}
          size={isMobile ? "h4" : "h2"}
          order={3}
          onClick={() => (window.location.href = "/job?id=" + id)}
          style={{ cursor: "pointer" }}
        >
          {title}
        </Title>
        <Text c={"gray.6"}>{description}</Text>
      </Box>
      <Button
        miw={rem(70)}
        color="orange.6"
        size={isMobile ? "xs" : "sm"}
        onClick={() => (window.location.href = "/job?id=" + id)}
      >
        Apply
      </Button>
    </Group>
  );

  return (
    <>
      <Box>
        <Navigation />
        <Flex justify={"space-between"} align={"center"} mt={"80px"} bg={"#fdf8f0"}>
          {<JoinUsTitle />}
          <Image src="/img/careers/team3.png" alt="Oculera" h={isMobile ? 150 : 350} />
        </Flex>
      </Box>
      <Box style={{ backgroundColor: "var(--oculera-surface-alt)" }} mih={"100vh"}>
        <Container>
          <Group wrap="nowrap">
            <Title p={"md"} mt={"md"} c={"blue.6"} order={isMobile ? 3 : 1}>
              Open Positions
            </Title>
          </Group>
          {jobs.map((job, i) => (
            <React.Fragment key={i}>
              {i !== 0 && <Divider />}
              <JobLine {...job} />
            </React.Fragment>
          ))}
          <Divider mt="xl" />
        </Container>
      </Box>
    </>
  );
}
